import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { Form, Input, InputNumber, Select } from "antd";
import style from "./style.module.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { SimpleInput } from "../../../../common/components/simpleInput";
import {
  useQueryLiftingMaterialTypeSelect,
  useQueryMachineMaterialEnergySelect,
  useQueryMachineMaterialFromSelect,
  useQueryMachineMaterialStateSelect,
} from "../../core/_hooks";
import { MaterialService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { handleNumericDecimalInput } from "../../../../common/utils/numericInputHandler";

type PropsType = {
  onFinish: () => void;
  initialValue?: any;
};
export const LevageForm = ({ onFinish, initialValue }: PropsType) => {
  const [form] = Form.useForm();

  const { data: stateOptions, isLoading: isLoadingState } =
    useQueryMachineMaterialStateSelect();
  const { data: energyOptions, isLoading: isLoadingEnergy } =
    useQueryMachineMaterialEnergySelect();
  const { data: fromOptions, isLoading: isLoadingFrom } =
    useQueryMachineMaterialFromSelect();
  const { data: typeOptions, isLoading: isLoadingType } =
    useQueryLiftingMaterialTypeSelect();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (initialValue) {
      form.setFieldsValue({
        ...initialValue,
        liftingMaterialType: initialValue?.liftingMaterialType
          ? {
              label: initialValue?.liftingMaterialType?.name,
              value: initialValue?.liftingMaterialType?.["@id"],
            }
          : null,
        materialFrom: initialValue?.materialFrom
          ? {
              label: initialValue?.materialFrom?.name,
              value: initialValue?.materialFrom?.["@id"],
            }
          : null,
        materialState: initialValue?.materialState
          ? {
              label: initialValue?.materialState?.name,
              value: initialValue?.materialState?.["@id"],
            }
          : null,
        materialUnit: initialValue?.materialUnit
          ? {
              label: initialValue?.materialUnit?.name,
              value: initialValue?.materialUnit?.["@id"],
            }
          : null,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        ...(initialValue
          ? {
              "@id": initialValue?.["@id"],
            }
          : {}),
        capacity: values?.capacity?.toString(),
        liftingMaterialType: values?.liftingMaterialType
          ? values?.liftingMaterialType?.value
          : null,
        materialFrom: values?.materialFrom ? values?.materialFrom?.value : null,
        materialState: values?.materialState
          ? values?.materialState?.value
          : null,
        materialUnit: values?.materialUnit ? values?.materialUnit?.value : null,
        quantity: values?.quantity.toString(),
      };

      if (!dataToPost?.id) {
        const res = await MaterialService.createLevageMaterial(dataToPost);

        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        const res = await MaterialService.updateLevageMaterial(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Référence"
                name={"reference"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Capacité (T)"
                name={"capacity"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <InputNumber min={0} className={style.form__input} onKeyDown={handleNumericDecimalInput}/>
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Propriétaire"
                name={"materialFrom"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={fromOptions}
                    loading={isLoadingFrom}
                  />
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Type"
                name={"liftingMaterialType"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={typeOptions}
                    loading={isLoadingType}
                  />
                }
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Quantité"
                name={"quantity"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <InputNumber className="w-100" disabled={initialValue} onKeyDown={handleNumericDecimalInput}/>
                }
              />
            </div>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Unité"
                name={"materialUnit"}
                customInput={
                  <InputSelect
                    uri="/api/material_units/select"
                    onChange={(e) => {
                      console.log("aaaa", e);
                    }}
                  />
                }
              />
            </div>
          </div>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Etat"
                name={"materialState"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={
                  <Select
                    labelInValue
                    options={stateOptions}
                    loading={isLoadingState}
                  />
                }
              />
            </div>
            <div className={style.form__item}></div>
          </div>
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
